
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenSplitRight as ObiScreenSplitRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-split-right.js';
 
 
 

 
 export const ObiScreenSplitRight = createComponent({
   react: React,
   tagName: 'obi-screen-split-right',
   elementClass: ObiScreenSplitRightElement,
   events: {
     
   }
  });
 
 